// queryClient.js
import { QueryClient } from "@tanstack/react-query";

// Create a client
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 300000, // 5 minutes
			cacheTime: 900000, // 15 minutes
			refetchOnWindowFocus: false,
			retry: 1,
		},
	},
});
//Ya se usa otra forma de guardar informacion, pero por si acaso lo dejare aqui aun